import React, { useState } from 'react';
import { Typography, Divider, Card } from 'antd';
import RecipeHeader from './components/RecipeHeader';
import ServingScaler from './components/ServingScaler';
import IngredientList from './components/IngredientList';
import DirectionsList from './components/DirectionsList';
import RecipeTags from './components/RecipeTags';
import OpenInAppButton from './components/OpenInAppButton';
import './styles.css';

const { Title } = Typography;

const DisplayMobile = ({ recipe }) => {
  const [servings, setServings] = useState(parseInt(recipe.servings) || 1);
  const baseServings = parseInt(recipe.servings) || 1;

  return (
    <div className="public-recipe-mobile">
      <Card style={{ margin: '12px', borderRadius: '8px' }}>
        <RecipeHeader
          name={recipe.name}
          description={recipe.description}
          image={recipe.coverImage}
        />

        <Divider />

        <ServingScaler
          currentServings={servings}
          onChange={setServings}
        />

        <Divider />

        <Title level={4}>Ingredients</Title>
        <IngredientList
          ingredients={recipe.ingredients}
          baseServings={baseServings}
          currentServings={servings}
        />

        <Divider />

        <Title level={4}>Directions</Title>
        <DirectionsList directions={recipe.directions} />

        {recipe.tags && recipe.tags.length > 0 && (
          <>
            <Divider />
            <RecipeTags tags={recipe.tags} />
          </>
        )}

        <Divider />

        <OpenInAppButton recipeId={recipe.id} />
      </Card>
    </div>
  );
};

export default DisplayMobile;
